<template>
  <component
    :is="componentName"
    v-bind="componentProps"
    :data-test="`filter-${filter.filterKey}`"
    @input="(val) => $emit('input', val)"
  ></component>
</template>

<script>
import MultiSelectFilter from './filterTypes/MultiSelectFilter'
import RangeFilter from './filterTypes/RangeFilter'
import SriRangeFilter from './filterTypes/SriRangeFilter'
import FreeTextFilter from './filterTypes/FreeTextFilter'
import BooleanFilter from './filterTypes/BooleanFilter'
import PerimeterFilter from './filterTypes/PerimeterFilter'
import CompanyFilterFilter from './filterTypes/CompanyFilterFilter'

// Dispatches one catalog filter to its filter_type component. Adding a new filter_type
// only means adding one entry here + one component, never touching the catalog-consuming views.
const COMPONENT_BY_TYPE = {
  RangeDouble: 'rangeFilter',
  RangeInt: 'rangeFilter',
  RangeDate: 'rangeFilter',
  MultiSelect: 'multiSelectFilter',
  FreeText: 'freeTextFilter',
  Boolean: 'booleanFilter',
  Perimeter: 'perimeterFilter',
  CompanyFilter: 'companyFilterFilter',
}

export default {
  name: 'filterField',
  components: {
    MultiSelectFilter,
    RangeFilter,
    SriRangeFilter,
    FreeTextFilter,
    BooleanFilter,
    PerimeterFilter,
    CompanyFilterFilter,
  },
  props: {
    filter: { type: Object, required: true },
    value: { default: null },
    // Scoring profiles: forwarded only to PerimeterFilter's placeholder prop. Unset (null)
    // in search, which doesn't need it (see PerimeterFilter.vue for why).
    perimeterPlaceholder: { type: String, default: null },
    // Scoring profiles: forwarded only to PerimeterFilter's hideInPerimeter prop. Unset
    // (false) in search, which keeps showing the "prodotti in perimetro" sub-select.
    hideInPerimeter: { type: Boolean, default: false },
    // Followed page: forwarded only to RangeFilter's label prop, to collapse the
    // outer label + generic "Da"/"A" labels into a single combined label per side. Unset
    // everywhere else.
    label: { type: String, default: null },
    // Followed page: forwarded only to MultiSelectFilter's showCount prop, to hide the
    // selected-count badge. Defaults to true (shown) everywhere
    // else, same as MultiSelectFilter's own default.
    showCount: { type: Boolean, default: true },
  },
  computed: {
    componentName() {
      // SriRange is a RangeInt filter_type but uses a dedicated chip selector, not
      // a generic slider — see SriRangeFilter.
      if (this.filter.filterKey === 'SriRange') {
        return 'sriRangeFilter'
      }
      return COMPONENT_BY_TYPE[this.filter.filterType] || null
    },
    componentProps() {
      const base = { filterKey: this.filter.filterKey, filterType: this.filter.filterType, value: this.value }
      if (this.filter.filterKey === 'SriRange') {
        return { value: this.value }
      }
      if (this.filter.filterType === 'MultiSelect') {
        return { filterKey: this.filter.filterKey, options: this.filter.options || [], value: this.value || [], showCount: this.showCount }
      }
      if (this.filter.filterType === 'Perimeter') {
        return {
          valueSchema: this.filter.valueSchema || {},
          value: this.value,
          placeholder: this.perimeterPlaceholder,
          hideInPerimeter: this.hideInPerimeter,
        }
      }
      if (this.filter.filterType === 'CompanyFilter') {
        return { value: this.value }
      }
      if (this.filter.filterType === 'RangeDate') {
        return { ...base, label: this.label }
      }
      return base
    },
  },
}
</script>
